import { render, staticRenderFns } from "./tppApps.vue?vue&type=template&id=584e1f03&scoped=true&"
import script from "./tppApps.vue?vue&type=script&lang=js&"
export * from "./tppApps.vue?vue&type=script&lang=js&"
import style0 from "./tppApps.vue?vue&type=style&index=0&id=584e1f03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584e1f03",
  null
  
)

export default component.exports